"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = exports.TestDialog = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

var _canUseDom = _interopRequireDefault(require("rc-util/lib/Dom/canUseDom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _getScrollBarSize = _interopRequireDefault(require("rc-util/lib/getScrollBarSize"));

var _object = _interopRequireDefault(require("object.omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _GrvPortal = _interopRequireDefault(require("../GrvPortal"));

var _getPropsWithPrefix3 = _interopRequireDefault(require("../utils/getPropsWithPrefix"));

var _getTabbableElements = _interopRequireDefault(require("../utils/getTabbableElements"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function disableScrolling() {
  var scrollBarSize = (0, _getScrollBarSize["default"])();
  var _document = document,
      body = _document.body;
  body.style.paddingRight = scrollBarSize + "px";
  body.style.overflow = 'hidden';
}

function enableScrolling() {
  var _document2 = document,
      body = _document2.body; // grv dialog overlay transition time is 250ms

  setTimeout(function () {
    body.style.removeProperty('padding-right');
    body.style.removeProperty('overflow');
  }, 250);
}

var propTypes = {
  active: _propTypes["default"].bool,
  cancelButtonType: _propTypes["default"].string,
  cancelText: _propTypes["default"].string,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  customFooter: _propTypes["default"].node,
  decision: _propTypes["default"].bool,
  hideButtons: _propTypes["default"].bool,
  hideCancel: _propTypes["default"].bool,
  hideOk: _propTypes["default"].bool,
  icon: _propTypes["default"].element,
  id: _propTypes["default"].string,
  // instanceOf Element, use object for server side rendering
  mountNode: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  okButtonType: _propTypes["default"].string,
  okText: _propTypes["default"].string,
  onCancel: _propTypes["default"].func,
  onOk: _propTypes["default"].func,
  portalClassName: _propTypes["default"].string,
  portalId: _propTypes["default"].string,
  portalStyle: _propTypes["default"].objectOf(_propTypes["default"].string),
  size: _propTypes["default"].oneOf(['normal', 'large']),
  theme: _propTypes["default"].string,
  title: _propTypes["default"].string
};
var defaultProps = {
  active: false,
  cancelButtonType: 'text',
  cancelText: 'No, Thanks',
  decision: false,
  hideButtons: false,
  hideCancel: false,
  hideOk: false,
  okButtonType: 'action',
  okText: 'Okay',
  onCancel: function onCancel() {},
  onOk: function onOk() {},
  portalClassName: null,
  size: 'normal',
  theme: '',
  title: ''
};

var Dialog = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Dialog, _Component);

  function Dialog(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.node = /*#__PURE__*/_react["default"].createRef();
    _this.tabbableElements = [];
    _this.originalActiveElement = null;

    _this.cancelDialog = function () {
      _this.clearDemandFocus();

      _this.props.onCancel();
    };

    _this.cancelDialogOverlay = function () {
      if (!_this.props.decision) {
        _this.cancelDialog();
      }
    };

    _this.clearDemandFocus = function () {
      _this.node.current.removeEventListener('keydown', _this.handleKeyDown);

      if (_this.originalActiveElement) {
        _this.originalActiveElement.focus();

        _this.originalActiveElement = null;
      }
    };

    _this.demandFocus = function () {
      var _document3 = document,
          activeElement = _document3.activeElement;
      _this.originalActiveElement = activeElement; // TODO - Is this always true?;

      _this.node.current.addEventListener('keydown', _this.handleKeyDown);

      _this.tabbableElements = (0, _getTabbableElements["default"])(_this.node.current);
      var _this$tabbableElement = _this.tabbableElements,
          firstElement = _this$tabbableElement[0];
      firstElement.focus();
    };

    _this.interceptBodyFocus = function () {
      if (document.activeElement === document.body) {
        _this.tabbableElements = (0, _getTabbableElements["default"])(_this.node.current);
        var _this$tabbableElement2 = _this.tabbableElements,
            firstElement = _this$tabbableElement2[0];
        firstElement.focus();
      }
    };

    _this.handleKeyDown = function (event) {
      var shiftKey = event.shiftKey,
          keyCode = event.keyCode;

      if (keyCode === 9) {
        var _document4 = document,
            activeElement = _document4.activeElement;
        var _this$tabbableElement3 = _this.tabbableElements,
            firstElement = _this$tabbableElement3[0];
        var lastElement = _this.tabbableElements[_this.tabbableElements.length - 1];

        if (activeElement === lastElement && !shiftKey) {
          event.preventDefault();
          firstElement.focus();
        } else if (activeElement === firstElement && shiftKey) {
          event.preventDefault();
          lastElement.focus();
        }
      }

      if (keyCode === 27) {
        _this.cancelDialog();
      }
    };

    _this.setFocus = function () {
      var active = _this.props.active;
      var hasNoOriginalElement = _this.originalActiveElement === null;

      if (active && hasNoOriginalElement) {
        _this.demandFocus();
      }
    };

    _this.setScrollHandler = function () {
      var active = _this.props.active;

      if (active) {
        disableScrolling();
      } else {
        enableScrolling();
      }
    };

    return _this;
  }

  var _proto = Dialog.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if ((0, _canUseDom["default"])()) {
      this.setScrollHandler();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var active = this.props.active;

    if (prevProps.active !== active && (0, _canUseDom["default"])()) {
      this.setScrollHandler();
      this.clearDemandFocus();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearDemandFocus();
    enableScrolling();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        active = _this$props.active,
        cancelButtonType = _this$props.cancelButtonType,
        cancelText = _this$props.cancelText,
        children = _this$props.children,
        className = _this$props.className,
        customFooter = _this$props.customFooter,
        decision = _this$props.decision,
        hideButtons = _this$props.hideButtons,
        hideCancel = _this$props.hideCancel,
        hideOk = _this$props.hideOk,
        icon = _this$props.icon,
        id = _this$props.id,
        mountNode = _this$props.mountNode,
        okButtonType = _this$props.okButtonType,
        okText = _this$props.okText,
        onCancel = _this$props.onCancel,
        onOk = _this$props.onOk,
        portalClassName = _this$props.portalClassName,
        portalId = _this$props.portalId,
        portalStyle = _this$props.portalStyle,
        size = _this$props.size,
        theme = _this$props.theme,
        title = _this$props.title,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["active", "cancelButtonType", "cancelText", "children", "className", "customFooter", "decision", "hideButtons", "hideCancel", "hideOk", "icon", "id", "mountNode", "okButtonType", "okText", "onCancel", "onOk", "portalClassName", "portalId", "portalStyle", "size", "theme", "title"]);

    var classes = (0, _classnames["default"])('grv-dialog', className, "grv-dialog--" + size, {
      'grv-dialog--active': active
    });
    var overlayClassName = (0, _classnames["default"])('grv-dialog__overlay', {
      'grv-dialog__overlay--dark': theme === 'dark'
    });
    var headingClassName = (0, _classnames["default"])('grv-dialog__heading', {
      'grv-dialog__heading--icon': icon
    });
    var labelId = id + "__label";
    var descId = id + "__desc";

    var _getPropsWithPrefix = (0, _getPropsWithPrefix3["default"])('cancelButton', otherProps),
        cancelButtonProps = _getPropsWithPrefix[0],
        cancelButtonPropsToRemove = _getPropsWithPrefix[1];

    var _getPropsWithPrefix2 = (0, _getPropsWithPrefix3["default"])('okButton', otherProps),
        okButtonProps = _getPropsWithPrefix2[0],
        okButtonPropsToRemove = _getPropsWithPrefix2[1];

    var cleanOtherProps = (0, _object["default"])(otherProps, cancelButtonPropsToRemove.concat(okButtonPropsToRemove));
    var dialogProps = {
      'aria-modal': true,
      role: 'dialog',
      'aria-labelledby': labelId
    };
    return /*#__PURE__*/_react["default"].createElement(_GrvPortal["default"], {
      className: portalClassName,
      id: portalId,
      mountNode: mountNode,
      style: portalStyle
    }, /*#__PURE__*/_react["default"].createElement("div", _extends({}, cleanOtherProps, {
      className: classes,
      id: id,
      ref: this.node,
      onTransitionEnd: function onTransitionEnd() {
        return _this2.setFocus();
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: overlayClassName,
      onClick: this.cancelDialogOverlay,
      onKeyPress: this.cancelDialogOverlay
    }), /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: "grv-dialog__container"
    }, dialogProps, {
      onClick: this.interceptBodyFocus
    }), title || icon ? /*#__PURE__*/_react["default"].createElement("h1", {
      className: headingClassName,
      id: labelId
    }, icon ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "grv-dialog__heading-icon"
    }, icon) : null, title) : null, !decision ? /*#__PURE__*/_react["default"].createElement("button", {
      className: "grv-dialog__close",
      onClick: this.cancelDialog,
      onKeyPress: this.cancelDialog,
      type: "button"
    }, "Close") : null, /*#__PURE__*/_react["default"].createElement("div", {
      id: descId,
      className: "grv-dialog__content"
    }, children), customFooter ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-dialog__footer grv-font"
    }, customFooter) : null, !customFooter && (!hideButtons || !(!hideCancel && !hideOk)) ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-dialog__buttons"
    }, !hideCancel ? /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, cancelButtonProps, {
      onClick: this.cancelDialog,
      type: cancelButtonType
    }), cancelText) : null, !hideOk ? /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, okButtonProps, {
      onClick: onOk,
      type: okButtonType
    }), okText) : null) : null)));
  };

  return Dialog;
}(_react.Component);

Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;
var TestDialog = Dialog;
exports.TestDialog = TestDialog;

var _default = (0, _withId["default"])(Dialog);

exports["default"] = _default;